module.exports = __webpack_public_path__ + "img/券包.2111366e.png";